
// TODO MVP consider expr-eval (https://www.npmjs.com/package/expr-eval) instead of mathjs compare sizes etc.
import { create, all } from 'mathjs'
import cloneDeep from 'lodash/cloneDeep'

const math = create(all, {})
const _ = { cloneDeep }

const emailRegEx = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/)

const now = new Date()

// TODO REFACTOR move date funcs to module?
const dateFormatToParts = (date) => {
  return {
    year: date.getFullYear() + '',
    month: ('0' + (date.getMonth() + 1)).slice(-2),
    day: ('0' + date.getDate()).slice(-2),
    hour: ('0' + date.getHours()).slice(-2),
    minute: ('0' + date.getMinutes()).slice(-2),
    seconds: ('0' + date.getSeconds()).slice(-2),
    dayPeriod: date.getHours() >= 12 ? 'pm' : 'am'
  }
}

// TODO MVP? Intl account timezones...
const toLocaleYYYYMMDDString = (optDate) => {
  optDate = optDate || new Date()

  const localeDate = dateFormatToParts(optDate)
  return (() => { // eslint-disable-next-line no-unused-vars
    var { year, month, day, hour, minute, second, dayPeriod } = localeDate
    return `${year}-${month}-${day}`
  })()
}

const fieldToVfield = (field) => {
  var vField = { component: '', event: '', binds: null }
  var vTextField = { component: 'v-text-field', event: 'change', binds: null }

  switch (field.type) {
  case 'text':
    if (!field.options.length) {
      vField = vTextField
      break
    } else {
      vField.component = 'v-combobox'
    }

    // eslint-disable-next-line no-fallthrough
  case 'select':
    if (field.type === 'select') {
      vField.component = 'v-autocomplete'
    }

    vField.event = 'input'

    vField.binds = (vm) => ({
      items: vm.groupify(
        vm[field.optionsComputedName] ||
            field.options.filter((option) => option.label.length)
      ),
      'item-text': 'label',
      'item-value': 'value',
      'menu-props': { closeOnContentClick: true, bottom: true }
    })

    break
  case 'textarea':
    vField = vTextField
    vField.component = 'v-textarea'
    break
  case 'email':
    vField = vTextField
    vField.binds = () => ({ type: 'email' })
    break
  case 'phone':
    vField = vTextField
    vField.binds = () => ({ type: 'tel' })
    break
  case 'datetime':
    vField = vTextField

    /* set min date and max date. Differs slightly from Formstack as Formstack
       Current Year + and Current Year - works on whole years, i.e. +0 means to end
       of current year, whereas this works based on the current date.

       Only supports Formstack Current Year + and Current Year -, not DISABLE DATES PAST
       or Date calculation
    */
    let minMax = {}

    if (field.year_minus !== '') {
      let yearMinus = Number(field.year_minus)
      let minDate = new Date(now)
      minDate.setFullYear(minDate.getFullYear() - yearMinus)
      minMax.min = toLocaleYYYYMMDDString(minDate)
      vField.min = minMax.min
    }

    if (field.year_plus !== '') {
      let yearPlus = Number(field.year_plus)
      let maxDate = new Date(now)
      maxDate.setFullYear(maxDate.getFullYear() + yearPlus)
      minMax.max = toLocaleYYYYMMDDString(maxDate)
      vField.max = minMax.max
    }

    vField.binds = () => ({ type: 'date', ...minMax })
    break
  case 'number':
    vField = vTextField
    vField.binds = () => ({
      type: 'number',
      min: field.min_value,
      max: field.max_value
    })
  }

  return vField
}

function formBehaviours(FormDef) {
  // TODO MVP move to transform
  FormDef.fields.forEach(field => {
    field.classes = field.classes.replace(/xs(\d+)/g, 'col-$1')
    field.classes = field.classes.replace(/sm(\d+)/g, 'content-col-sm-$1')
  })

  // TODO MVP move to transform
  const hasAddressAuto = FormDef.fields.some(field => field.type === 'address_auto')
  if (!hasAddressAuto) {
    FormDef.fields.forEach(field => {
      if (field.type === 'address') {
        var newField = _.cloneDeep(field)
        newField.type = 'address_auto'
        newField.name = field.name + '_auto'
        newField.nameId = newField.name + '_' + field.id
        FormDef.fields.push(newField)
      }
    })
  }

  const fieldsByNameId = FormDef.fields.reduce((fieldsAcc, field, index) => {
    if (field.nameId.length) {
      fieldsAcc[field.nameId] = field
    }
    return fieldsAcc
  }, {})

  const fieldsByName = FormDef.fields.reduce((fieldsAcc, field, index) => {
    if (field.name.length) {
      fieldsAcc[field.name] = field
    }
    return fieldsAcc
  }, {})

  /* visibility 1 */
  FormDef.fields.forEach(field => {
    const getFieldVisibility = function () {
      if (this.hidden === true || this.hidden === '1') { return false }
      const logic = this.logic

      if (!logic) { return true }
      if (!('action' in logic)) { return true }

      function checkCondition(value, item) {
        if (!fieldsByNameId[item.field].visible) { return false }

        switch (item.condition) {
        case 'equals': return model[item.field].value === item.option
        case 'notequals': return model[item.field].value !== item.option
        case 'greaterthan': return model[item.field].value > item.option
        case 'lessthan': return model[item.field].value < item.option
        case 'included in': return (model[item.field].value || []).includes(item.option)
        case 'is not included in': return !((model[item.field].value || []).includes(item.option))
        }
      }

      if (logic.action === 'show') {
        if (logic.conditional === 'all') {
          return logic.checks.every(item => checkCondition(model[item.field].value, item))
        } else if (logic.conditional === 'any') {
          return logic.checks.some(item => checkCondition(model[item.field].value, item))
        }
      }
    }

    Object.defineProperty(field, 'fieldVisible', { get: getFieldVisibility })
  })

  /* visibility 2 */
  FormDef.fields.forEach(field => {
    const getSubSectionVisibility = function () {
      if (!field.isSubField) { return true }

      return fieldsByNameId[field.subSectionNameId].fieldVisible
    }

    Object.defineProperty(field, 'subSectionVisible', { get: getSubSectionVisibility })

    const getVisibility = function () {
      return field.subSectionVisible && field.fieldVisible
    }

    Object.defineProperty(field, 'visible', { get: getVisibility })
  })

  /* rules */
  FormDef.fields.forEach((field, index) => {
    field.rules = [(v) => {
      if (!field.required || !field.visible) { return true }

      let valid = false

      if (field.type === 'checkbox' && field.options.length > 1) {
        valid = typeof v !== 'undefined' && v != null
        if (valid) {
          valid = v.length > 0
        }
      } else {
        valid = !!v || v === 0
      }
      return valid || (field.errorMessage || 'This field is required.')
    }
    ]

    field.vfield = fieldToVfield(field)

    if (field.name === 'email' || field.type === 'calculation') {
      field.readonly = true
      field.disabled = true
    }

    if (field.type === 'email') {
      field.rules.push((v) => {
        return !field.visible || emailRegEx.test(v) || 'Enter a valid email address.'
      })
    }

    if (field.type === 'datetime') {
      if (field.vfield.min) {
        field.rules.push((v) => {
          if (field.visible) {
            return v == null || v.length === 0 || v >= field.vfield.min || ('Date must be => ' + field.vfield.min + '.')
          }
          return true
        })
      }
      if (field.vfield.max) {
        field.rules.push((v) => {
          if (field.visible) {
            return v == null || v.length === 0 || v <= field.vfield.max || ('Date must be <= ' + field.vfield.max + '.')
          }
          return true
        })
      }
    }

    if (field.type === 'number' || field.type === 'calculation') {
      const minValue = 'min_value' in field && field.min_value !== '' ? Number(field.min_value) : undefined
      const maxValue = 'max_value' in field && field.max_value !== '' ? Number(field.max_value) : undefined
      if (typeof (minValue && maxValue) !== 'undefined') {
        if (minValue === maxValue) {
          field.rules.push((v) => {
            if (field.visible) {
              return v == null || v.length === 0 || Number(v) === Number(maxValue) || 'Value must equal ' + field.max_value + '.'
            } else {
              return true
            }
          })
        } else {
          field.rules.push((v) => {
            if (field.visible) {
              return v == null || v.length === 0 || (v >= minValue && v <= maxValue) || 'Value must be between ' + field.min_value + ' and ' + field.max_value + ', inclusive.'
            } else {
              return true
            }
          })
        }
      } else if (typeof minValue !== 'undefined') {
        field.rules.push((v) => {
          if (field.visible) {
            return v == null || v.length === 0 || v >= minValue || 'Value must be greater than or equal to ' + field.min_value + '.'
          } else {
            return true
          }
        })
      } else if (typeof maxValue !== 'undefined') {
        field.rules.push((v) => {
          if (field.visible) {
            return v == null || v.length === 0 || v <= maxValue || 'Value must be less than or equal to ' + field.max_value + '.'
          } else {
            return true
          }
        })
      }
    }
  })

  /* triggers */
  var triggers = []
  FormDef.fields.filter(field => field.type === 'richtext').forEach(field => {
    if (field.section_text.includes('is-trigger') && 'logic' in field && field.logic != null && 'action' in field.logic) {
      field.isTriggerText = true

      const getTriggered = function () {
        return field.isTriggerText && field.visible
      }
      Object.defineProperty(field, 'isTriggered', { get: getTriggered })

      const fieldTriggers = field.logic.checks.map(check =>
        ({ textNameId: field.nameId, questionNameId: check.field }))
      triggers = triggers.concat(fieldTriggers)
    }
  })
  triggers.forEach(trigger => {
    const questionField = fieldsByNameId[trigger.questionNameId]
    const textField = fieldsByNameId[trigger.textNameId]

    questionField.isTriggerQuestion = true

    const getTriggered = function () {
      return textField.isTriggered
    }
    Object.defineProperty(questionField, 'isTriggered', { get: getTriggered })
  })

  var model = FormDef.fields.reduce((fieldsAcc, field, index) => {
    // TODO MVP? multiselects?
    fieldsAcc[field.nameId] = { value: field.type === 'checkbox' ? [] : null }
    return fieldsAcc
  }, {})

  // convert logic checks to account for checkbox array
  FormDef.fields.filter(field => 'logic' in field && field.logic != null && 'action' in field.logic).forEach(field => {
    if (field.logic.action === 'show') {
      field.logic.checks.forEach(item => {
        if (fieldsByNameId[item.field].type === 'checkbox') {
          if (item.condition === 'equals') {
            item.condition = 'included in'
          } else if (item.condition === 'notequals') {
            item.condition = 'is not included in'
          }
        }
      })
    }
  })

  FormDef.fields.filter(field => field.type === 'calculation').forEach(field => {
    field.calculation = math.compile(field.calculation)

    field.calculation_fn = (visibleValues) => {
      if (field.visible) {
        const value = field.calculation.eval({ model: visibleValues }).toFixed(2)
        model[field.nameId].value = Number(value)
        return value
      } else { return 0 }
    }
  })

  const sectionObj = {
    fields: [],
    rules: [() => true],
    valid: null,
    visited: false,
    departed: false
  }

  const FormDefSectioned = FormDef.fields.reduce((sectionAcc, field, index) => {
    const section = sectionAcc[field.section] || _.cloneDeep(sectionObj)
    section.fields.push(field)
    sectionAcc[field.section] = section
    return sectionAcc
  }, {})

  const metaSection = _.cloneDeep(sectionObj)
  metaSection.type = 'meta'
  const lastSectionKey = Object.keys(FormDefSectioned).slice(-1)[0]
  metaSection.fields.push({
    type: 'section',
    section_heading: 'Document',
    section_text: '',
    section_break: true,
    visible: true,
    nameId: 'metaSectionHeading',
    classes: ''
  })
  FormDefSectioned[+lastSectionKey + 1] = metaSection

  // TODO MVP? implement 'Hide Label'

  /* TODO MVP? form notes:

  Unused:
  - Do any of the following apply to Child X
  - Any beneficiary likely to be unable to.../Which
  - Life Interest or other Trust to be created

  Other:
  - Could combine 'Who would you like to appoint as a Guardian' with 'Executors - Guardian'
*/

  /* Get all selection fields with dynamic options (field labels wrapped with []) and
   turn the options into computed arrays
*/
  // TODO MVP? treat labels and values separately (currently only value is evaluated and then copied to label)
  const dynamicOptionFieldsComputeds = (() => {
    const dynamicOptionFields = FormDef.fields.filter(field => field.options && field.options.some(option => option.value.indexOf('[') !== -1))

    const common = dynamicOptionFields.reduce((acc, field, index) => {
      // generate a key that's common to option lists that are identical
      const optionsKey = field.options.map(option => option.value).join('').replace(/[^0-9a-z]/gi, '')

      if (!(optionsKey in acc)) {
        let newOptionsArray = field.options.reduce((optionsAcc, option, index) => {
          var optionString = option.value
          const sourceFieldNames = optionString.match(/(\[.*?\])/g)

          if (sourceFieldNames) {
            var newOptionString = optionString
            newOptionString = sourceFieldNames.reduce((acc, fieldName, index) => {
              var adjFieldName = fieldName.replace(/[-()]/g, '').replace(/[^A-z\d]/g, '_').toLowerCase()
              adjFieldName = adjFieldName.slice(1, -1)
              if (adjFieldName in fieldsByName) {
                let adjFieldNameId = fieldsByName[adjFieldName].nameId
                acc = acc.replace(fieldName, '" + `${(fieldsByNameId["' + adjFieldNameId + '"].visible && model["' + adjFieldNameId + '"].value) || null}` + "')
              }

              return acc
            }, newOptionString)

            optionsAcc.push('"' + newOptionString + '"')
          } else {
            optionsAcc.push('"' + optionString + '"')
          }
          return optionsAcc
        }, [])

        let computed = function () {
        /* This uses an eval to turn a string into a template string.
           It should be safe, as only matching fieldnames are eval'd, everthing else is treated as a literal
           */
          // eslint-disable-next-line no-eval
          return newOptionsArray.map(optionString => eval(optionString))
            .filter(option => option.length && option.indexOf('null') === -1)
            .map(option => ({ label: option, value: option }))
        }
        acc[optionsKey] = computed
      }
      field.optionsComputedName = optionsKey

      return acc
    }, {})

    return common
  })()

  const sections = Object.keys(FormDefSectioned).length

  return {
    fieldsByNameId: fieldsByNameId,
    fieldsByName: fieldsByName,
    form: {
      formDef: FormDef,
      formDefSectioned: FormDefSectioned,
      model: model,
      sections: sections
    },
    computeds: {
      ...dynamicOptionFieldsComputeds
    }
  }
}

export default formBehaviours
